var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showSeparator)?_c('q-separator'):_vm._e(),_c('froala',{class:_vm.editorClass,attrs:{"id":"froala-editor","value":_vm.value,"config":_vm.config,"edit":false},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }